import React from 'react';
import {
  useScrollTrigger,
  Slide,

} from '@mui/material';
import {
  Menu as MenuIcon,
  LocalPizza,
  LunchDining,
  Fastfood,
  Icecream,
  LocalDining,
  Star,
  AccessTime,
  Phone,
  Email,
  LocationOn,
  Facebook,
  Twitter,
  Instagram,
  Search,
  ShoppingCart,
  Close,
  Home,
  RestaurantMenu,
  Info,
  Support,
  ContactPhone,
  Article,

} from '@mui/icons-material';
import Layout from './components/layout/Layout';
import AppRoutes from './routes/AppRoutes';

interface HideOnScrollProps {
  children: React.ReactNode;
  window?: () => Window | undefined;
}

function HideOnScroll(props: HideOnScrollProps) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children as React.ReactElement}
    </Slide>
  );
}

// Icon mapping function
export const getIconComponent = (iconName: string): React.ReactNode => {
  const iconMap: { [key: string]: React.ReactNode } = {
    Home: <Home />,
    RestaurantMenu: <RestaurantMenu />,
    Info: <Info />,
    Support: <Support />,
    ContactPhone: <ContactPhone />,
    Article: <Article />,
    LunchDining: <LunchDining />,
    LocalPizza: <LocalPizza />,
    Fastfood: <Fastfood />,
    Icecream: <Icecream />,
    LocalDining: <LocalDining />,
    Star: <Star />,
    AccessTime: <AccessTime />,
    Phone: <Phone />,
    Email: <Email />,
    LocationOn: <LocationOn />,
    Facebook: <Facebook />,
    Twitter: <Twitter />,
    Instagram: <Instagram />,
    Search: <Search />,
    ShoppingCart: <ShoppingCart />,
    Close: <Close />,
  };

  return iconMap[iconName] || <Home />;
};



export default function App() {
   return (
    <Layout>
      <AppRoutes />
    </Layout>
  );
}
